import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { motion } from "framer-motion";
import backImage from "../assets/back.jpg";
import logo from "../assets/Logo2.png";
import okIcon from "../assets/ok.svg";

// ✅ Styled Components (same as login page)
const ConfirmContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${backImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const ConfirmBox = styled(motion.div)`
  font-family: "Inter", sans-serif;
  background: rgba(48, 136, 139, 0.15); /* Glass effect */
  backdrop-filter: blur(12px);
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 550px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const Logo = styled.img`
  width: 200px;
  margin-bottom: 20px;
  filter: drop-shadow(0px 4px 8px rgba(255, 255, 255, 0.3));
`;

const MessageContainer = styled(motion.div)`
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: ${(props) => (props.success ? "green" : "red")};
  margin-top: 20px;
`;

const IconContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  img {
    width: 50px;
    height: 50px;
  }
`;

// 🔔 webhook helper – email confirmed
async function sendEmailConfirmedWebhook(payload) {
  try {
    await axios.post(
      "https://hook.eu2.make.com/8nusrwvim7eotwcw1s8a85i9asreyxd6",
      payload,
      { timeout: 8000 }
    );
  } catch (err) {
    // nie psujemy UX jak Make padnie
    console.warn(
      "Make webhook error (email confirmed):",
      err?.response?.status || err?.message
    );
  }
}

function ConfirmEmail() {
  const [message, setMessage] = useState("Trwa weryfikacja konta...");
  const [isSuccess, setIsSuccess] = useState(false);
  const isRequestSent = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      if (isRequestSent.current) return;
      isRequestSent.current = true;

      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");

      if (!token) {
        setMessage("Brak tokenu weryfikacyjnego.");
        return;
      }

      try {
        const response = await axios.get(
          `https://server229256.nazwa.pl/verify-email?token=${token}`
        );
        console.log("✅ Backend Response:", response.data);

        if (response.data.success) {
          setMessage("Konto zostało pomyślnie zweryfikowane! Przekierowanie...");
          setIsSuccess(true);

          // próbujemy wyciągnąć dane z odpowiedzi, jeśli backend je zwraca
          const { email, username, accountType } = response.data || {};

          // 🔔 fire-and-forget webhook do Make
          sendEmailConfirmedWebhook({
            event: "user_email_confirmed",
            token, // możesz też usunąć jeśli nie chcesz wysyłać tokenu
            email,
            username,
            account_type: accountType || "full", // jeśli chcesz rozróżniać full/demo
            confirmed_at: new Date().toISOString(),
            page_url: typeof window !== "undefined" ? window.location.href : "",
            user_agent:
              typeof navigator !== "undefined" ? navigator.userAgent : "",
            source: "AnalizyIRaporty.pl",
          });

          setTimeout(() => navigate("/login"), 5000);
        } else {
          setMessage(
            response.data.message || "Nie udało się zweryfikować konta."
          );
          setIsSuccess(false);
        }
      } catch (error) {
        console.error(
          "❌ Error verifying email:",
          error.response?.data || error.message
        );
        setMessage("Błąd serwera podczas weryfikacji konta.");
        setIsSuccess(false);
      }
    };

    verifyUser();
  }, [navigate]);

  return (
    <ConfirmContainer>
      <ConfirmBox
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Logo src={logo} alt="Logo" />
        <MessageContainer success={isSuccess}>{message}</MessageContainer>

        {isSuccess && (
          <IconContainer
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <img src={okIcon} alt="Success" />
          </IconContainer>
        )}
      </ConfirmBox>
    </ConfirmContainer>
  );
}

export default ConfirmEmail;
